import { render } from "./DashboardVet.vue?vue&type=template&id=477b1b88&scoped=true"
import script from "./DashboardVet.vue?vue&type=script&lang=js"
export * from "./DashboardVet.vue?vue&type=script&lang=js"

import "./DashboardVet.vue?vue&type=style&index=0&id=477b1b88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477b1b88"]])

export default __exports__